import { render, staticRenderFns } from "./location-modal.vue?vue&type=template&id=6705c1e0&scoped=true"
import script from "./location-modal.vue?vue&type=script&lang=js"
export * from "./location-modal.vue?vue&type=script&lang=js"
import style0 from "./location-modal.vue?vue&type=style&index=0&id=6705c1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6705c1e0",
  null
  
)

export default component.exports